// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Modal Styles --- */
.Modal_modalBackdrop__Lq6oj {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.Modal_modalContent__axM59 {
  background: var(--neutral-white, white);
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.Modal_modalContentSm__4aGeN { max-width: 24rem; }
.Modal_modalContentMd__ZVrr1 { max-width: 28rem; }
.Modal_modalContentLg__1VzpD { max-width: 32rem; }
.Modal_modalContentXl__fEcry { max-width: 36rem; }

.Modal_modalHeader__ipZSv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #eee;
}

.Modal_modalTitle__JvsLa {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--primary-dark-blue);
}

.Modal_modalCloseButton__Hazzk {
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
}
.Modal_modalCloseButton__Hazzk:hover {
  color: #4b5563;
}

.Modal_modalBody__zZlcF {
  margin-bottom: 1rem;
}

.Modal_modalFooter__0gfiC {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding-top: 12px;
  border-top: 1px solid #eee;
}`, "",{"version":3,"sources":["webpack://./src/components/Modal/Modal.module.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;AACb;;AAEA,+BAAkB,gBAAgB,EAAE;AACpC,+BAAkB,gBAAgB,EAAE;AACpC,+BAAkB,gBAAgB,EAAE;AACpC,+BAAkB,gBAAgB,EAAE;;AAEpC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B","sourcesContent":["/* --- Modal Styles --- */\n.modalBackdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  padding: 16px;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modalContent {\n  background: var(--neutral-white, white);\n  padding: 25px;\n  border-radius: 12px;\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);\n  width: 100%;\n}\n\n.modalContentSm { max-width: 24rem; }\n.modalContentMd { max-width: 28rem; }\n.modalContentLg { max-width: 32rem; }\n.modalContentXl { max-width: 36rem; }\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 12px;\n  margin-bottom: 12px;\n  border-bottom: 1px solid #eee;\n}\n\n.modalTitle {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n}\n\n.modalCloseButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #9ca3af;\n}\n.modalCloseButton:hover {\n  color: #4b5563;\n}\n\n.modalBody {\n  margin-bottom: 1rem;\n}\n\n.modalFooter {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  padding-top: 12px;\n  border-top: 1px solid #eee;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalBackdrop": `Modal_modalBackdrop__Lq6oj`,
	"modalContent": `Modal_modalContent__axM59`,
	"modalContentSm": `Modal_modalContentSm__4aGeN`,
	"modalContentMd": `Modal_modalContentMd__ZVrr1`,
	"modalContentLg": `Modal_modalContentLg__1VzpD`,
	"modalContentXl": `Modal_modalContentXl__fEcry`,
	"modalHeader": `Modal_modalHeader__ipZSv`,
	"modalTitle": `Modal_modalTitle__JvsLa`,
	"modalCloseButton": `Modal_modalCloseButton__Hazzk`,
	"modalBody": `Modal_modalBody__zZlcF`,
	"modalFooter": `Modal_modalFooter__0gfiC`
};
export default ___CSS_LOADER_EXPORT___;
